import type { OrganizationDetailTab, ResolveOrganizationDetailTabParams } from '../types';

const resolveOrganizationDetailTab = ({
    pathname,
}: ResolveOrganizationDetailTabParams): OrganizationDetailTab => {
    const segments = pathname.split('/').filter(Boolean);
    const tabSegment = segments[3];

    if (
        tabSegment === 'services' ||
        tabSegment === 'subscription' ||
        tabSegment === 'costs' ||
        tabSegment === 'workflows'
    ) {
        return tabSegment;
    }

    return 'services';
};

export default resolveOrganizationDetailTab;
